import { Injectable, Injector } from '@angular/core';
import log from 'loglevel';
import remote from 'loglevel-plugin-remote';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ReferenceService } from 'src/app/services/reference.service';

@Injectable({
    providedIn: 'root'
})
export class LogService {
    public logger=log 
    constructor(private referenceService :  ReferenceService,
        protected injectorObj:Injector,
    ) {
        log.setLevel( environment.logger.level);
        const customJSON = log => ({
            //msg: JSON.parse(log.message),
            msg: log.message,
            level: log.level.label,
            stacktrace: log.stacktrace
         });
        let router: Router | null = null;
        try {
          router = this.injectorObj.get(Router);
        } catch (error) {
          router = null;
        }
        let currentPath = "/";
        if (router && router.url) {
          currentPath = router.url.split("?")[0].split("#")[0];
        }
        const sessionUuid = this.referenceService.getReferenceUUID();
        const logSessionId = sessionUuid;
        const flowSessionId = sessionUuid + ':' + currentPath;
         remote.apply(log, {
            format: customJSON,
            url: environment.logger.serverLoggingUrl,
            headers : {
                "app-meta":JSON.stringify({ flow_session_id:flowSessionId, log_session_id: logSessionId }),
                "reference_uuid" : this.referenceService.getReferenceUUID(),

            }
         });
    }
    public info(...data) {
        log.info(JSON.stringify(data));
    }
    public debug(...data) {
        log.debug(JSON.stringify(data));
    }
    public error(...data) {
        log.error(JSON.stringify(data));
    }
    public exception(...data) {
        log.trace(JSON.stringify(data));
    }
    
  }